import { AuthPluginFacade } from '../../services/JWeb/facades/AuthPluginFacade';
import IApplicationService from '../../services/applicationService/IApplicationService';
import { IAuthTokenService } from '../../services/authTokenService';
import { ITenantHandlerService } from '../../services/tenantHandler';
import TenantObserver, {
  TenantEvents
} from '../../services/tenantHandler/TenantObserver';
import { internalLogger } from '../../interface/v1/clientOsLogger';
import { TokenType } from '../../services/JWeb/JWebEnums';
import { AccessToken } from '../../services/JWeb/types';
import InitializationTokenCache from '../../services/JWeb/cache/InitializationTokenCache';

export type SetFirstTenantForNativeType = {
  authTokenService: IAuthTokenService;
  tenantHandlerService: ITenantHandlerService;
  applicationService: IApplicationService;
};

export default class SetFirstTenantForNative {
  private _authTokenService: IAuthTokenService;
  private _tenantHandlerService: ITenantHandlerService;

  constructor({
    authTokenService,
    tenantHandlerService
  }: SetFirstTenantForNativeType) {
    this._authTokenService = authTokenService;
    this._tenantHandlerService = tenantHandlerService;
  }

  public async init(): Promise<void> {
    //TODO: Phillipe should check if this is right without await.
    this.setInitialTenants();
    TenantObserver.subscribe(
      TenantEvents.SET_TENANT_HANDLER_KEY,
      this.setFirstTenant
    );
  }

  public setInitialTenants = async (): Promise<void> => {
    try {
      const isLoggedInData = (await AuthPluginFacade.isLoggedIn()) as {
        value: boolean;
      };

      if (!isLoggedInData?.value) {
        return;
      }
      const jwebToken = await InitializationTokenCache.getToken({
        tokenProviderOptions: { tokenType: TokenType.user }
      });
      const jwebTokenTenantId =
        this._authTokenService?.getTenantIdFromGivenToken(
          (jwebToken as AccessToken)?.tokenValue
        );
      const shellTokenTenantId = this._authTokenService?.getTenantIdFromToken();
      if (jwebTokenTenantId !== shellTokenTenantId) {
        /* istanbul ignore next */
        internalLogger?.debug?.(
          'Setting in ClientOS the following tenant:',
          jwebTokenTenantId
        );
        return this._tenantHandlerService?.setInitialTenants([
          {
            id: jwebTokenTenantId,
            level: this._tenantHandlerService?.START_TENANT_LEVEL
          }
        ]);
      }
    } catch (error) {
      console.error('Error setting initial tenant:', error);
    }
  };

  public setFirstTenant = async (): Promise<void> => {
    const isLoggedInData = (await AuthPluginFacade.isLoggedIn()) as {
      value: boolean;
    };

    if (!isLoggedInData?.value) {
      return;
    }

    const jwebToken = await InitializationTokenCache.getToken({
      tokenProviderOptions: { tokenType: TokenType.user }
    });

    const jwebTokenTenantId = this._authTokenService?.getTenantIdFromGivenToken(
      (jwebToken as AccessToken).tokenValue
    );

    const tenantHandlerTenantId = this._tenantHandlerService?.getTenantId();
    if (jwebTokenTenantId && !tenantHandlerTenantId) {
      /* istanbul ignore next */
      internalLogger?.debug?.(
        'Setting in ClientOS the following tenant:',
        jwebTokenTenantId
      );
      await this._tenantHandlerService?.setTenant(
        jwebTokenTenantId,
        this._tenantHandlerService?.START_TENANT_LEVEL,
        { reload: false }
      );
      return;
    }
  };
}
